module.exports = __webpack_public_path__ + "img/works-03_my-portfolio.a1b2faa2.png";